export const featuredProjects = [
  {
    id: 1,
    name: "Modern Appartement Renovatie",
    description: "Complete transformatie van een 120m² appartement",
    category: "Interieur",
    image: "https://public.readdy.ai/ai/img_res/2d3363540c458d100cb91e007b765e4d.jpg"
  },
  {
    id: 2,
    name: "Badkamer Verbouwing",
    description: "Luxe badkamer met natuursteen en moderne afwerking",
    category: "Badkamer",
    image: "https://readdy.ai/api/search-image?query=luxury%20modern%20bathroom%20renovation%20with%20natural%20stone%20tiles%20walk-in%20shower%20minimalist%20design%20clean%20white%20surfaces%20contemporary%20fixtures%20elegant%20lighting&width=800&height=600&seq=proj2&orientation=landscape"
  },
  {
    id: 3,
    name: "Keuken Renovatie",
    description: "Open keuken met hoogwaardige materialen",
    category: "Keuken",
    image: "https://readdy.ai/api/search-image?query=modern%20open%20kitchen%20renovation%20with%20white%20cabinets%20marble%20countertops%20stainless%20steel%20appliances%20minimalist%20design%20clean%20lines%20natural%20light%20contemporary%20style&width=800&height=600&seq=proj3&orientation=landscape"
  }
];

export const beforeAfterProjects = [
  {
    id: 1,
    location: "Keuken",
    category: "keuken",
    beforeImage: "https://static.readdy.ai/image/7b34421e175c8bb5abddaf2fbf57a1a1/d03b0b9fb2cb65f5b2a3369d5d2a2b48.jpeg",
    afterImage: "https://static.readdy.ai/image/7b34421e175c8bb5abddaf2fbf57a1a1/93707f43bfa1ce2845d9aee6eb31e3e3.jpeg"
  },
  {
    id: 2,
    location: "Badkamer",
    category: "badkamer",
    beforeImage: "https://static.readdy.ai/image/7b34421e175c8bb5abddaf2fbf57a1a1/106089be3020ccf212abd4083c7d478b.jpeg",
    afterImage: "https://static.readdy.ai/image/7b34421e175c8bb5abddaf2fbf57a1a1/b8831df1f6bddcf7c78d563f421bc58a.jpeg"
  },
  {
    id: 3,
    location: "Woonkamer",
    category: "appartement",
    beforeImage: "https://static.readdy.ai/image/7b34421e175c8bb5abddaf2fbf57a1a1/95e3c00c8fcf435a5aeb3f3c4a2c0907.jpeg",
    afterImage: "https://static.readdy.ai/image/7b34421e175c8bb5abddaf2fbf57a1a1/a04bd069ace643a13ce120980a4ce88a.jpeg"
  },
  {
    id: 4,
    location: "Slaapkamer",
    category: "appartement",
    beforeImage: "https://readdy.ai/api/search-image?query=old%20living%20room%20before%20renovation%20dark%20walls%20outdated%20flooring%20poor%20lighting%20cluttered%20space%20needs%20improvement%20grayscale%20filter&width=600&height=800&seq=before4&orientation=portrait",
    afterImage: "https://readdy.ai/api/search-image?query=modern%20living%20room%20after%20renovation%20bright%20white%20walls%20wooden%20floors%20excellent%20lighting%20minimalist%20design%20contemporary%20furniture%20beautiful%20transformation&width=600&height=800&seq=after4&orientation=portrait"
  },
  {
    id: 5,
    location: "Buitengevel",
    category: "appartement",
    beforeImage: "https://static.readdy.ai/image/7b34421e175c8bb5abddaf2fbf57a1a1/f5d99188afcf4e3c6f09c4fcf1da26d3.jpeg",
    afterImage: "https://static.readdy.ai/image/7b34421e175c8bb5abddaf2fbf57a1a1/d801db9a394f09a35b5fd87834812f4e.jpeg"
  },
  {
    id: 6,
    location: "Vloeren",
    category: "appartement",
    beforeImage: "https://static.readdy.ai/image/7b34421e175c8bb5abddaf2fbf57a1a1/c63db93cace061e1febde62d9d2596b8.jpeg",
    afterImage: "https://static.readdy.ai/image/7b34421e175c8bb5abddaf2fbf57a1a1/e2fd3305a9be46eba91b21aff392a5d8.jpeg"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sophie van der Berg",
    project: "Appartement Renovatie",
    avatar: "SB",
    review: "NGP heeft ons appartement volledig getransformeerd. De aandacht voor detail en vakmanschap waren uitzonderlijk. Zeer tevreden met het resultaat!",
    color: "#E8F5E9"
  },
  {
    id: 2,
    name: "Mark Jansen",
    project: "Badkamer Verbouwing",
    avatar: "MJ",
    review: "Professioneel team dat precies wist wat ze deden. De badkamer ziet er nu luxe en modern uit. Aanrader!",
    color: "#E3F2FD"
  },
  {
    id: 3,
    name: "Lisa de Vries",
    project: "Keuken Renovatie",
    avatar: "LV",
    review: "Fantastisch werk! De nieuwe keuken overtreft al onze verwachtingen. Goede communicatie en netjes afgewerkt.",
    color: "#FFF3E0"
  },
  {
    id: 4,
    name: "Peter Bakker",
    project: "Woonkamer Renovatie",
    avatar: "PB",
    review: "NGP heeft onze woonkamer omgetoverd tot een prachtige ruimte. Zeer vakkundig en betrouwbaar.",
    color: "#F3E5F5"
  },
  {
    id: 5,
    name: "Emma Visser",
    project: "Complete Renovatie",
    avatar: "EV",
    review: "Van begin tot eind perfect geregeld. Het team was professioneel en het eindresultaat is prachtig!",
    color: "#FCE4EC"
  },
  {
    id: 6,
    name: "Tom Hendriks",
    project: "Kantoor Verbouwing",
    avatar: "TH",
    review: "Uitstekende service en kwaliteit. Ze hebben ons kantoor getransformeerd naar een moderne werkruimte.",
    color: "#E0F2F1"
  }
];